import { Transfer_ID, DROPDOWN_DETAILS } from "../Constants/constants";
import { getMaxTranferId } from "../Services/Dashboard/tableGridService";

export const transformPositionCodeDetailsByTrasferId = async (
  editVerticals,
  positionCodeIndex,
  refIndex,
  refValue,
  verticalValue
) => {
  const { positionCodeAdditionalDetails } =
    editVerticals[positionCodeIndex] || {};
  positionCodeAdditionalDetails[refIndex].refValue = refValue;
  const filteredPositionCodeData = positionCodeAdditionalDetails.filter(
    (item) => item.refType !== Transfer_ID
  );
  const isPositionCodeDataThere = filteredPositionCodeData.every(
    (item) => !!item?.refValue
  );
  if (isPositionCodeDataThere) {
    if(verticalValue?.refValue === DROPDOWN_DETAILS.RETAILER){
      filteredPositionCodeData.push(verticalValue);
    }
    try {
      const res = await getMaxTranferId(filteredPositionCodeData);
      const maxTrasferId = res.data.maxTransferId + 1;
      for (const pcdObj of positionCodeAdditionalDetails) {
        if (pcdObj.refType === Transfer_ID) {
          pcdObj.refValue = maxTrasferId;
          break;
        }
      }
      return [editVerticals, null];
    } catch (e) {
      return [null, editVerticals];
    }
  }
};
